/**
 * Local i18n config for React SPA.
 */
export const i18nConfig = {
  defaultLocale: "en" as const,
  locales: ["en", "fr"] as const,
  defaultNS: "common" as const,
  ns: ["common"] as const,
  returnObjects: false as const,
  interpolation: { escapeValue: false } as const,
};

export type I18nConfig = typeof i18nConfig;
